import { Community } from '@common/model/community';

export enum CommunityMode {
    Default = 'Default',
    RegistrationDisabled = 'RegistrationDisabled',
    Hidden = 'Hidden',
}

export class EnjpCommunity extends Community {
    communityMode: CommunityMode;
}
